import { render, staticRenderFns } from "./arviointityokalu-kysymys-lomake-vastauksilla.vue?vue&type=template&id=30f19c51&scoped=true&"
import script from "./arviointityokalu-kysymys-lomake-vastauksilla.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalu-kysymys-lomake-vastauksilla.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalu-kysymys-lomake-vastauksilla.vue?vue&type=style&index=0&id=30f19c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f19c51",
  null
  
)

export default component.exports